import { useSyncExternalStore } from 'react';

const subscribeToClientSnapshot = (): (() => void) => (): void => {};

const getClientSnapshot = (): boolean => true;

const getServerSnapshot = (): boolean => false;

const useIsCSR = (): boolean => {
  return useSyncExternalStore(subscribeToClientSnapshot, getClientSnapshot, getServerSnapshot);
};

export default useIsCSR;
